import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import PublicLayout from '~/components/PublicLayout'
import OrderRequestStatus from '~/components/OrderRequestStatus'

const App: React.FC = () => {
  const { id }: any = useParams()
  return (
    <PublicLayout>
      <OrderRequestStatus orderKey={id} />
    </PublicLayout>
  )
}

export default App
